<script>
    import DefaultButton from "../components/DefaultButton.svelte";
    import GeneralDetailPage from "./GeneralDetailPage.svelte";
    import FormattedStartDate from "../components/FormattedStartDate.svelte";
    import ContentSection from "../common/ContentSection.svelte";
    import { push } from "svelte-spa-router";
    import { _ } from "svelte-i18n";
    import { getEntity } from "../api-client";
    import { getEvent, getEventFromFondationAPI } from "../content/data/events";

    const url = window.location.href.toString().slice(-6);
    const onsite = 'onsite';
    export let params = {};
    $: if (params.id) {
        window.scrollTo(0, 0);
    }
    $: eventId = params.id;

    $: event = getEvent(eventId);
</script>

<main>
    {#await event then event}
        <GeneralDetailPage
            title={event.title}
            titleImage={event.titleImage}
            shortDescription={event.shortDescription ?? ""}
            description={event.description ?? ""}
            headerAction="SHARE"
        >
            <div slot="preTitleArea">
                <div class="headline-xs pretitle">{event.eventType}</div>
            </div>

            <div slot="subTitleArea">
                {#if event.startDate && event.endDate}
                    <FormattedStartDate
                        startDate={event.startDate}
                        endDate={event.endDate}
                        isHeadline="true"
                    />
                {/if}
            </div>

            <div slot="content">
                {#if event.sections}
                    {#each event.sections as section, index}
                        <ContentSection title={section.title}>
                            <div slot="content">
                                {@html section.html}
                            </div>
                        </ContentSection>
                        {#if index < event.sections.length - 1}
                            <div class="divider-h divider" />
                        {/if}
                    {/each}
                {/if}
            </div>
            <div
                slot="subDescriptionArea"
                style="margin-top: 64px;"
                class="saaltexte-button"
            >
                {#if event.fk_saalheft && url === onsite}
                    <DefaultButton
                        isPrimary={false}
                        text={$_("navigate_exhibition_texts")}
                        on:click={() => push(`/saalheft/${event.fk_saalheft}`)}
                    />
                {/if}
            </div>
            <div slot="floatingButton">
                {#if event.fk_livestream}
                    <DefaultButton
                        text={$_("now_live_caption")}
                        on:click={() => {
                            push(`/live/${event.fk_livestream}`);
                        }}
                    />
                {/if}
                {#if event.ticket && url !== onsite}
                    <div style="height: 16px;" />
                    <DefaultButton
                        text={$_("buy_ticket_caption")}
                        on:click={() => {
                            window.open(event.ticket, "_blank");
                        }}
                    />
                {/if}
            </div>
        </GeneralDetailPage>
    {/await}
</main>

<style>
    .divider {
        margin: 16px 0px;
        width: auto;
    }

    @media (min-width: 1440px) {
        .pretitle {
            font-size: 24px;
        }
    }
</style>
